// extracted by mini-css-extract-plugin
export default {"bodyContainer":"style_bodyContainer__oxpuo"};